import { LeafCircleOutlineIcon } from './LeafCircleOutlineIcon';

/**
 * author: Jeff Anders
 * id C480BC5A-402E-46EB-B913-51AFA64FA26E
 * name leaf-circle-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/leaf-circle-outline.svg
 * tags
 * - Agriculture 
 * - Nature 
 */
export const GreenCircleOutlineIcon = LeafCircleOutlineIcon;
export default GreenCircleOutlineIcon